import type { PhotoNoteType } from 'src/providers/photo-notes/photo-notes';

/**
 * Rental accounts keep two sets of arrival instructions on the property: the pro columns
 * Edit Property always had, and guest_* twins that the guidebook shows guests. Other
 * accounts keep a single set, so their guidebook reads and writes the pro columns.
 */
export const GUEST_ADDRESS_FIELDS = {
  paid_parking: 'guest_paid_parking',
  parking_spot: 'guest_parking_spot',
  parking_pay_with: 'guest_parking_pay_with',
  max_parking_cost: 'guest_max_parking_cost',
  parking_notes: 'guest_parking_notes',
  home_access: 'guest_home_access',
} as const;

export type ProAddressField = keyof typeof GUEST_ADDRESS_FIELDS;
export type GuestAddressField = (typeof GUEST_ADDRESS_FIELDS)[ProAddressField];
export type GuidebookPhotoKind = 'parking' | 'access';

/** Address column the guidebook binds a pro field to. Fields without a guest twin pass through. */
export function guidebookAddressField(field: string, isRental: boolean): string {
  if (!isRental || !Object.prototype.hasOwnProperty.call(GUEST_ADDRESS_FIELDS, field)) { return field; }
  return GUEST_ADDRESS_FIELDS[field as ProAddressField];
}

/** Photo note type the guidebook shows for a card's photos. */
export function guidebookPhotoType(kind: GuidebookPhotoKind, isRental: boolean): PhotoNoteType {
  return isRental ? `guest_${kind}` : kind;
}

export function isRentalAccount(): boolean {
  return localStorage.getItem('isRentalClient') === 'true';
}
